/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const installmentPlanService = {
  getList: (params: any) =>
    request.get('/installment-product-plan', { params }),
  getInstallmentPlanById: (id: any) =>
    request.get(`/installment-product-plan/${id}`),
  getInstallmentById: (id: any, params: any) =>
    request.get(`/installment-product-plans/${id}`, { params }),
  createInstallment: (data: any) =>
    request.post('/installment-product-plan', data),
  deleteInstallment: (id: any) =>
    request.delete(`/installment-product-plan/${id}`),
  updateInstallment: (id: any, data?: any) =>
    request.put(`/installment-product-plan/${id}`, data)
};

export default installmentPlanService;
